/**
 * Base API for the creation of others.
 */
export class API {
    /**
     * @param restService - Instance of the RestService class.
     */
    constructor(restService) {
        this.restService = restService;
    }
    /**
     * Gets the RestService associated with this instance.
     * @returns RestService object
     */
    getRestService() {
        return this.restService;
    }
}
